export const settings = {
    
    
    // enableColResize: true,
    rowHeight: 50,
    // enableRangeSelection: true,
    defaultColDef: {
        enableValue: true,
        sortable: true,
        filter: true,
        floatingFilter: true,
        enableRowGroup: true,
        enablePivot: true,
        resizable: true,
        enableBrowserTooltips:true,
        wrapHeaderText: true,
        autoHeaderHeight: true,
        // wrapText: true,
        // autoHeight:true
        
        // rowSelection: 'multiple',
        // groupSelectsChildren: true,
        // editable: true
      }

}